/**
 * Ô số điện thoại: cờ + mã vùng; giá trị `value`/`onChange` theo E.164 khi hợp lệ.
 *
 * Cần import CSS thư viện (file này đã `import 'react-phone-number-input/style.css'`).
 * Import lib dùng `react-phone-number-input/min` + ESM để tránh lỗi bundle CRA với `min/index.cjs`.
 */
import React from 'react';
// `react-phone-number-input/min` + dist ESM: tránh CRA bundle nhầm `min/index.cjs` thành URL (React coi default export là string).
import PhoneInputLib from 'react-phone-number-input/min';
import 'react-phone-number-input/style.css';
import { cn } from './cn';
export function PhoneInput({ id, value, onChange, disabled, placeholder = 'Phone number', defaultCountry = 'US', className, 'aria-invalid': ariaInvalid, }) {
    return (React.createElement("div", { className: cn('phone-input-field w-full min-w-0', className) },
        React.createElement(PhoneInputLib, { id: id, international: true, defaultCountry: defaultCountry, countryCallingCodeEditable: false, placeholder: placeholder, value: value || undefined, onChange: (v) => onChange(v !== null && v !== void 0 ? v : ''), disabled: disabled, className: "PhoneInput", "aria-invalid": ariaInvalid, autoComplete: "tel" })));
}
